import { useGetAllSlotData } from "api/stats";
import NumberHighlight from "./NumberHighlight";
import { CancelledSlotStatistics } from "./SlotStatistics";
import { DashboardGridItem } from "./styles";
import { Divider } from "@mindlercare/ui-web";

type TimeslotsDashboardItemProps = {
  psychologistUserId: number;
  fromDate: Date;
  toDate: Date;
  previousFromDate: Date;
  previousToDate: Date;
  dateRangeLengthInDays: number;
};

export const CancelledSlotsDashboardGridItem = ({
  fromDate,
  toDate,
  previousFromDate,
  previousToDate,
  psychologistUserId: selectedPsychologistUserId,
  dateRangeLengthInDays,
}: TimeslotsDashboardItemProps): JSX.Element => {
  const { data: currentData } = useGetAllSlotData({
    fromDate: fromDate,
    toDate: toDate,
    psychologistUserId: selectedPsychologistUserId,
  });

  const { data: previousData } = useGetAllSlotData({
    fromDate: previousFromDate,
    toDate: previousToDate,
    psychologistUserId: selectedPsychologistUserId,
  });

  const slots = currentData?.slots;
  const previousSlots = previousData?.slots;

  const cancelledTotal = slots?.statuses.CANCELED.total ?? 0;
  const previousCancelledTotal = previousSlots?.statuses.CANCELED.total ?? 0;

  const differenceCancelled = cancelledTotal - previousCancelledTotal;

  return (
    <DashboardGridItem>
      <NumberHighlight
        title="Cancelled slots"
        value={cancelledTotal}
        difference={{
          changeAmount: differenceCancelled,
          coloring: differenceCancelled < 0 ? "positive" : "negative",
          text: `compared to previous ${dateRangeLengthInDays} days`,
        }}
      />
      <Divider />
      {slots && <CancelledSlotStatistics slots={slots} />}
    </DashboardGridItem>
  );
};
